module.exports = __webpack_public_path__ + "img/domain-alt.1283a8a6.svg";